import {combineReducers} from 'redux';
import register from './register'
const createReducer = (asyncReducers) =>
    combineReducers({
        register,
        ...asyncReducers
    });

export default createReducer;
